import { useQuery } from "@tanstack/react-query";
import { isAllBusiness } from "@/api";
import { demoUsers } from "@/demo";
import { useRootAPI } from "@/api";

export function useGetUsers(
  args: Partial<{
    businessId: string;
    userIsDemo?: boolean;
    enabled?: boolean;
  }>,
) {
  const rootAPI = useRootAPI();

  return useQuery({
    queryKey: ["users", args.businessId, args.userIsDemo],
    queryFn: async () => {
      if (args.userIsDemo) {
        return demoUsers;
      }
      if (isAllBusiness(args.businessId!)) {
        return (await rootAPI.getOrganizationUsers()).data;
      }
      return (
        await rootAPI.getUsersByBusiness({
          business_id: args.businessId!,
        })
      ).data;
    },
    enabled: (args.enabled ?? true) && (Boolean(args.businessId) || args.userIsDemo),
  });
}
